
// @ is an alias to /src
import { Component, Vue, Prop } from "vue-property-decorator";
import * as Model from "@gigalot/data-models";
import { DimssaButton } from "@/components/shared/dimssa-button.vue";
import type { ButtonState } from "@/components/shared/dimssa-button.vue";
import lodash from "lodash";
const Subscriber = require("@jetblack/graphql-reconnect-client");
import { createClient } from "@/helpers/graphql-ws-rtc-adapter";
import ReplayEditDialog from "@/components/ReplayEditDialog.vue";
import BreadcrumbTrail from "@/components/BreadcrumbTrail.vue";
import FeedScheduleRations from "@/components/FeedScheduleRations.vue";
import { homeBreadcrumbs } from "@/utils/breadcrumbs";
import { pauseJobsService } from "@/helpers/pause-jobs";

@Component({
  components: {
    ReplayEditDialog,
    DimssaButton,
    BreadcrumbTrail,
    FeedScheduleRations,
  },
})
export default class FeedSchedule extends Vue {
  @Prop(Boolean) replay!: boolean;
  name = "feedSchedule";
  loading = true;
  search = "";
  rationPlan: Model.RationPlan[] = [];
  feedPlan: any = {};
  feedSchedules: Model.FeedingSchedule = { typename: "FeedingSchedule", guid: "", date: Date.now(), feedingScheduleItems: [] };
  selectedFeedSchedules: Model.FeedingScheduleItem[] = [];
  feedResults = [];
  loaders: Model.Loader[] = [];
  selectedLoader = "";
  selectedOperator: string | null = "";

  get operators(): Model.Operator[] {
    return (this.$store.getters["storage"]().Operators || []).filter((operator: Model.Operator) => operator.active && operator.electronicID);
  }
  tempprogress = 20;
  bufferValue = 100;
  tableKey = 0;
  tableHeight = 700;
  scrollLockActive = false;
  prevBodyOverflow = "";
  prevHtmlOverflow = "";
  snack = false;
  snackColor = "";
  snackText = "";
  errorText = "";
  errorDialog = false;
  amountToAdd = 0;
  patchRationGuid = "";
  mergeRationGuid = "";
  mergeRationDialog = false;
  mergeRationItem: Model.FeedingScheduleItem | null = null;
  merging = false;
  sessionToAddTo = { text: 1, value: 0 };
  customFooterProps = {
    itemsPerPageOptions: [10, 20, 50, 100, 200, -1],
  };
  fixedHeader = [{}];
  headers = [
    {
      text: "Kraal",
      value: "kraalId",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
      width: 50,
    },
    {
      text: "Type",
      value: "kraalType",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
      width: 50,
    },
    {
      text: "Animals",
      value: "animals",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
      width: 50,
    },
    {
      text: "Ration",
      value: "ration",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
      width: 50,
    },
    {
      text: "Feed Allocated",
      value: "feedAllocated",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
      width: 100,
    },
    {
      text: "Actual Fed",
      value: "actualFed",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
      width: 100,
    },
    {
      text: "Tractor",
      value: "tractorAllocated",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
      width: 30,
    },
    {
      text: "Progress",
      value: "progress",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
      width: 150,
    },
    { text: "", value: "data-table-expand", width: 20 },
  ];
  expanded = [];

  updateTableHeight() {
    this.$nextTick(() => {
      const tableRef = this.$refs.feedScheduleTable as Vue | undefined;
      if (!tableRef || !tableRef.$el) return;
      const tableEl = tableRef.$el as HTMLElement;
      const wrapperEl = tableEl.querySelector(".v-data-table__wrapper") as HTMLElement | null;
      const footerEl = tableEl.querySelector(".v-data-footer") as HTMLElement | null;
      const rect = (wrapperEl ?? tableEl).getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const footerHeight = footerEl ? footerEl.getBoundingClientRect().height : 0;
      const bottomPadding = 32;
      const nextHeight = Math.max(240, Math.floor(viewportHeight - rect.top - footerHeight - bottomPadding));
      if (nextHeight !== this.tableHeight) {
        this.tableHeight = nextHeight;
      }
    });
  }

  disablePageScroll() {
    if (this.scrollLockActive) return;
    const body = document.body;
    const html = document.documentElement;
    this.prevBodyOverflow = body.style.overflow;
    this.prevHtmlOverflow = html.style.overflow;
    body.style.overflow = "hidden";
    html.style.overflow = "hidden";
    this.scrollLockActive = true;
  }

  restorePageScroll() {
    if (!this.scrollLockActive) return;
    document.body.style.overflow = this.prevBodyOverflow || "";
    document.documentElement.style.overflow = this.prevHtmlOverflow || "";
    this.scrollLockActive = false;
  }

  async mounted() {
    this.$store.dispatch("user/addFirebaseCallback", this.getFeedSchedule);
    this.$store.dispatch("user/addFirebaseCallback", this.getFeedScheduleSocket);
    this.$store.dispatch("user/addFirebaseCallback", pauseJobsService.getPauseStatus.bind(pauseJobsService));
    this.loaders = lodash.cloneDeep(this.$store.getters["storage"]().Loaders) as Model.Loader[];
    await pauseJobsService.getPauseStatus();
    window.addEventListener("resize", this.updateTableHeight);
    this.updateTableHeight();
    if (!this.$props.replay) {
      this.disablePageScroll();
    }
  }
  get moment() {
    return this.$store.state.moment;
  }
  getSessions(item: Model.FeedingScheduleItem) {
    return item.feedAllocations.map((alloc, index) => {
      return { text: index + 1, value: index };
    });
  }
  getAnimalCount(kraalId: string) {
    let itemPlan = lodash.find((this.feedPlan as Model.FeedingPlan).FeedingPlanItems, { kraalId: kraalId }); //TODO: replace kraal ID with Kraal guid
    return itemPlan?.numberAnimals;
  }

  destroyed() {
    if (this.graphQLUnsubscribe) {
      this.graphQLUnsubscribe();
    }
    if (this.graphQLSubscriber) {
      this.graphQLSubscriber();
    }
    window.removeEventListener("resize", this.updateTableHeight);
    this.restorePageScroll();
  }

  urlws = "wss://pi.gigalot.systems:7778/api/ws";
  options = {};

  subscriptions = `subscription($guid:String!) {
${this.$props.replay ? "replay" : ""}feedSchedule(guid:$guid){
       typename
          guid
          feedingScheduleItems{
            typename
            guid
            kraalId
            kraalGuid
            ration
            rationGuid
            feedAllocated
            activeFeed
            actualFed
            sequence
            tractorAllocated
            priority
            time
            feedAllocations{
              typename
              feedAllocated
              actualFed
              active
              allocated
              percentage
              scheduledAllocatedFeed
              ration
              rationGuid
            }
          }
        }
    }`;

  variables = { guid: this.$store.state.user.location.guid };
  operationName = null;

  graphQLSubscriber: any = undefined;
  graphQLUnsubscribe: any = undefined;

  get pauseButtonState(): ButtonState {
    return pauseJobsService.state.pauseButtonState;
  }

  get pauseStatus() {
    return pauseJobsService.state.pauseStatus;
  }

  get pauseButtonText() {
    return this.pauseStatus === "Paused" ? "Resume Jobs" : "Pause Jobs";
  }

  get pauseChipColor() {
    if (this.pauseStatus === "Paused") return "red";
    if (this.pauseStatus === "Running") return "green";
    return "grey";
  }

  async togglePauseJobs() {
    const result = await pauseJobsService.togglePauseJobs();
    if (!result) return;

    this.snack = true;
    this.snackColor = result.snackColor;
    this.snackText = result.snackText;
  }

  async getFeedScheduleSocket() {
    if (this.$store.state.useP2PConn) {
      await this.getOnlineFeedScheduleSocket();
    } else {
      await this.getOnsiteFeedScheduleSocket();
    }
  }

  async getOnsiteFeedScheduleSocket() {
    this.graphQLSubscriber = Subscriber.graphQLReconnectingSubscriber(
      this.urlws,
      this.options,
      (error: any, subscribe: any) => {
        try {
          if (!(error || subscribe)) {
            // Normal closure.
            console.log("connected to socket");
            this.$store.state.wsDialogVisible = false;
            return;
          }
          if (error) {
            console.log("error connecting to socket");
            if (error.event.type === "close") {
            } else {
              this.$store.state.wsDialogVisible = true;
              console.error(error);
            }
          }
          console.log("socket connected");
          this.graphQLUnsubscribe = subscribe(this.subscriptions, this.variables, this.operationName, (error: any, data: any) => {
            if (!(error || subscribe)) {
              console.log("subscribe success");
              // Normal closure
              this.$store.state.wsDialogVisible = false;
              return;
            }
            if (error) {
              console.log("error subscribing");
              if (error.event.type === "close") {
              } else {
                this.$store.state.wsDialogVisible = true;
                console.error(error);
              }
            }
            this.$store.state.wsDialogVisible = false;
            console.log("receiving data");
            const schedule = this.replay ? data?.replayfeedSchedule : data?.feedSchedule;
            if (!schedule) return;
            this.feedSchedules = schedule;
            this.loading = false;
          });
        } catch (err) {}
      },
      15000,
      3,
      "graphql-ws"
    );
  }

  async getOnlineFeedScheduleSocket() {
    console.log(this.subscriptions);
    let variables = { guid: this.$store.state.user.location.guid, user: this.$store.state.user.user.uid };

    const subscribe = (subscriptions: string, variables: any, callback: (error: any, data: any) => Promise<void>) => {
      const client = createClient();
      let unsubscribe = client?.subscribe(
        {
          query: subscriptions,
          variables: variables,
        },
        {
          next: (message: any) => callback(undefined, message.data),
          error: (err: any) => {
            throw err;
          },
          complete: () => console.log("subscription completed"),
        }
      );
      return unsubscribe;
    };

    this.graphQLUnsubscribe = subscribe(this.subscriptions, variables, async (error: any, data: any) => {
      this.$store.state.wsConnected = true;
      if (!(error || subscribe)) {
        console.log("subscribe success");
        this.$store.state.wsDialogVisible = false;
        // Normal closure
        return;
      }
      if (error) {
        console.log("error subscribing");

        this.$store.state.wsConnected = false;
        if (error.event.type === "close") {
        } else {
          this.$store.state.wsDialogVisible = true;
          console.error(error);
          //    throw error;
        }
      }
      this.$store.state.wsDialogVisible = false;
      this.$store.state.wsConnected = true;
      console.log("almost there");

      console.log(data);
      const schedule = this.replay ? data?.replayfeedSchedule : data?.feedSchedule;
      if (!schedule) return;
      this.feedSchedules = schedule;
      this.loading = false;
    });
  }

  subloading = false;

  async getFeedResults(item: any, value: boolean) {
    if (this.replay) return;
    let kraalGuid = item.item.kraalGuid;
    let results: Model.FeedingResult[] = [];
    try {
      console.log("FeedResults( " + kraalGuid + " )");
      this.subloading = true;
      let query = {
        gql: `query FeedResult($guid: String!, $kraalGuid: String!){
        FeedResult(guid:$guid, kraalGuid: $kraalGuid){
          timestamp
          latitude
          longitude
          amountFed
          isManual
          kraalID
          kraalGuid
          rationGuid
          operatorID
          tractorID
          trailerID
          rationFed
        }
      }`,
        variables: {
          guid: this.$store.state.user.location.guid,
          kraalGuid: kraalGuid,
        },
      };
      let json = await this.$store.dispatch("graphQl", query);
      this.feedResults = json.data.FeedResult;
    } catch (err) {
      console.log("getFeedResult -> error: " + err);
    }
    this.subloading = false;
  }

  async getFeedSchedule() {
    try {
      console.log("FeedSchedule()");
      this.loading = true;
      let gql = `query($guid:String!){
        FeedSchedule(guid:$guid){
       typename
          guid
          feedingScheduleItems{
            typename
            guid
            kraalId
            kraalGuid
            ration
            rationGuid
            feedAllocated
            actualFed
            sequence
            activeFeed
            priority
            tractorAllocated
            time
            feedAllocations{
              typename
              feedAllocated
              actualFed
              active
              allocated
              percentage
              scheduledAllocatedFeed
              ration
              rationGuid
            }
          }
        }
        FeedPlan(guid:$guid) {
          FeedingPlanItems{
            kraalId
            rationPlanGuid
            numberAnimals
            currentRation{
              colour
              type
            }
          }
        }
         RationPlans(guid:$guid) {
          typename
          guid
          creationDate
          rationItems{
            typename
            guid
            ration
            defaultDays
            colour
            order
          }
        }
      }`;

      let json = await this.$store.dispatch("graphQl", { gql, variables: { guid: this.$store.state.user.location.guid } });
      this.feedPlan = json.data.FeedPlan;
      if (!this.replay) this.feedSchedules = json.data.FeedSchedule;
      this.rationPlan = json.data.RationPlans ?? [];
    } catch (err) {
      console.log("getFeedSchedule -> error: " + err);
    }
    this.loading = false;
  }

  getKraalType(guid: string) {
    let kraals = this.$store.getters[`storage`]().Kraals as Model.Kraal[];
    let kraal = lodash.find(kraals, { guid: guid });
    if (kraal) return kraal.kraalType;
  }

  getKraalName(guid: string) {
    let kraals = this.$store.getters[`storage`]().Kraals as Model.Kraal[];
    let kraal = lodash.find(kraals, { guid: guid });
    if (kraal) return kraal.kraalId;
  }

  getTrailerName(guid: string) {
    let trailers = this.$store.getters[`storage`]().Trailers as Model.Trailer[];
    let trailer = lodash.find(trailers, { electronicID: guid });
    if (trailer) return trailer.wagonRegistration;
  }

  getTractorName(guid: string) {
    let tractors = this.$store.getters[`storage`]().Tractors as Model.Tractor[];
    let tractor = lodash.find(tractors, { electronicID: guid });
    if (tractor) return tractor.registrationNumber;
  }

  getOperatorName(guid: string) {
    let operators = this.$store.getters[`storage`]().Operators as Model.Operator[];
    let operator = lodash.find(operators, { electronicID: guid });
    if (operator) return operator.operatorFullName;
  }

  getColor(kraalId: string) {
    let itemPlan = lodash.find(this.feedPlan.FeedingPlanItems, { kraalId: kraalId }); //TODO: replace kraal ID with Kraal guid
    return itemPlan?.currentRation?.colour ?? "black";
  }

  isBlend(item: Model.FeedingScheduleItem) {
    const plan = lodash.find(this.feedPlan.FeedingPlanItems, { kraalId: item.kraalId });
    if (plan?.currentRation?.type) return plan.currentRation.type === "blend";
    return new Set((item.feedAllocations ?? []).map((allocation) => allocation.rationGuid || allocation.ration).filter(Boolean)).size > 1;
  }

  getMergeRationOptions(item: Model.FeedingScheduleItem): { ration: string; rationGuid: string }[] {
    const rations = new Map<string, { ration: string; rationGuid: string }>();
    for (const allocation of item.feedAllocations ?? []) {
      const rationGuid = allocation.rationGuid || item.rationGuid;
      if (!rationGuid || rations.has(rationGuid)) continue;
      rations.set(rationGuid, { ration: allocation.ration || item.ration, rationGuid });
    }
    if (!rations.size && item.rationGuid) rations.set(item.rationGuid, { ration: item.ration, rationGuid: item.rationGuid });
    return [...rations.values()];
  }

  open(item: Model.FeedingScheduleItem) {
    this.amountToAdd = 0;
    this.patchRationGuid = this.getMergeRationOptions(item)[0]?.rationGuid ?? "";
  }

  getRationColours(kraalId: string): Record<string, string> {
    const itemPlan = lodash.find(this.feedPlan.FeedingPlanItems, { kraalId });
    const plan = this.rationPlan.find((candidate) => candidate.guid === itemPlan?.rationPlanGuid);
    const colours: Record<string, string> = {};
    for (const ration of plan?.rationItems ?? []) {
      if (!ration.colour) continue;
      if (ration.rationGuid) colours[ration.rationGuid] = ration.colour.toLowerCase();
      if (ration.ration) colours[ration.ration] = ration.colour.toLowerCase();
    }
    return colours;
  }

  isUnfed(kraalId: string) {
    let itemPlan = lodash.find((this.feedPlan as Model.FeedingPlan).FeedingPlanItems, { kraalId: kraalId }); //TODO: replace kraal ID with Kraal guid
    let feedItem = lodash.find((this.feedSchedules as Model.FeedingSchedule).feedingScheduleItems, { kraalId: kraalId });
    if (itemPlan?.numberAnimals) {
      if (feedItem?.actualFed) {
        //there is something fed
        return false;
      } else return true;
    }
    return false;
  }

  isPartialfed(kraalId: string) {
    //get feedschedule
    //get animal count
    //if animals and feed not complete
    let itemPlan = lodash.find((this.feedPlan as Model.FeedingPlan).FeedingPlanItems, { kraalId: kraalId }); //TODO: replace kraal ID with Kraal guid
    let feedItem = lodash.find((this.feedSchedules as Model.FeedingSchedule).feedingScheduleItems, { kraalId: kraalId });
    if (itemPlan?.numberAnimals) {
      if (feedItem?.feedAllocated) {
        if (feedItem?.actualFed < feedItem?.feedAllocated) {
          //there is something fed
          return true;
        }
      }
    }
    return false;
  }

  backColor(feedResult: Model.FeedingResult, scheduled: Model.FeedingScheduleItem) {
    //if wrong ration fed
    if (feedResult.rationGuid != scheduled.rationGuid) return "incorrect-ration";
    else return "correct";
  }
  page = 1;
  forceRerender() {
    // let pageHolder = this.page;
    // console.log(pageHolder);
    this.tableKey += 1;
    // this.page = pageHolder;
    // console.log(pageHolder);
  }

  cancel() {
    this.snack = true;
    this.snackColor = "blue lighten-1";
    this.snackText = "Canceled";
  }
  close() {}

  saveFed(item: any) {
    if (item.actualFed > 2000) {
      //show dialog if dialog accepted
      this.$store.commit("popup/displayYesNo", {
        message: "Are you sure? The amount entered is very large (>2000kg)",
        yesAction: () => {
          this.updateServer(item, undefined, this.selectedOperator || "");
        },
      });
    } else {
      this.updateServer(item, undefined, this.selectedOperator || "");
    }
  }

  async saveAddFeedToAllocation(item?: Model.FeedingScheduleItem) {
    if (this.replay || !item) return;
    const amount = Number(this.amountToAdd);
    if (!Number.isFinite(amount) || amount <= 0) {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Enter a patch amount greater than zero";
      return;
    }
    try {
      this.selectedFeedSchedules = [item];
      const rationGuid = this.isBlend(item) ? this.patchRationGuid : undefined;
      await this.putMergeSession(item.kraalGuid, false, rationGuid);
      await this.getFeedSchedule();
      const updated = this.feedSchedules.feedingScheduleItems.find((schedule) => schedule.guid === item.guid);
      if (!updated) throw Error("Feeding schedule not found after merging");
      const editedItem = lodash.cloneDeep(updated);
      editedItem.feedAllocated = editedItem.actualFed + amount;
      editedItem.feedAllocations[0].feedAllocated = editedItem.actualFed + amount;
      await this.updateServer(editedItem, amount);
      this.amountToAdd = 0;
      await this.getFeedSchedule();
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Patch saved";
    } catch (err) {
      this.errorDialog = true;
      this.errorText = `Error saving patch: ${err} ${item.kraalId}`;
    }
  }

  get patchUserMetadata(): string {
    const user = this.$store.state.user.user;
    return JSON.stringify({ userId: user.uid, userName: user.displayName || "", userEmail: user.email || "" });
  }

  async updateServer(editedItem?: any, patchKg?: number, operatorId?: string) {
    if (this.replay) return;
    console.log(editedItem);
    if (editedItem) {
      if (this.selectedLoader) {
        console.dir(this.selectedLoader);
      }
      try {
        console.log("updateServer()");
        let guid_string = JSON.stringify(editedItem);
        let json = await this.$store.dispatch(
          "graphQl",
          {
            gql: `mutation addFeedSchedule($guid:String!, $input: FeedingScheduleItemInput!, $tractorId: String!${
              patchKg === undefined ? "" : ", $patchKg: Float, $user: String"
            }${operatorId === undefined ? "" : ", $operatorId: String"}) {
            addFeedSchedule(guid:$guid, input: $input, tractorId:$tractorId${patchKg === undefined ? "" : ", patchKg:$patchKg, user:$user"}${
              operatorId === undefined ? "" : ", operatorId:$operatorId"
            })
          }`,
            variables: {
              guid: this.$store.state.user.location.guid,
              input: editedItem,
              tractorId: this.selectedLoader ?? "",
              patchKg,
              user: patchKg === undefined ? undefined : this.patchUserMetadata,
              operatorId,
            },
          },
          { root: true }
        );

        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Data saved";
        if (operatorId !== undefined && this.expanded?.some((item:any) => item.kraalGuid === editedItem.kraalGuid)) {
          await this.getFeedResults({ item: editedItem }, true);
        }
      } catch (err) {
        console.log(err);
        this.errorDialog = true;
        this.errorText = `Error saving to server: ${err} ${editedItem.kraalId}`;

        throw err;
      }
    }
  }

  async mergeSessions() {
    if (this.replay || this.merging) return;
    const items = [...this.selectedFeedSchedules];
    if (items.length === 1 && this.isBlend(items[0])) {
      this.mergeRationItem = items[0];
      this.mergeRationGuid = this.getMergeRationOptions(items[0])[0]?.rationGuid ?? "";
      this.mergeRationDialog = true;
      return;
    }
    await this.mergeFeedSchedules(items);
  }

  async confirmMergeRation() {
    if (!this.mergeRationItem || !this.mergeRationGuid || this.merging) return;
    await this.mergeFeedSchedules([this.mergeRationItem], this.mergeRationGuid);
  }

  async mergeFeedSchedules(items: Model.FeedingScheduleItem[], rationGuid?: string) {
    if (this.replay || this.merging) return;
    this.merging = true;
    try {
      for (const item of items) await this.putMergeSession(item.kraalGuid, true, items.length === 1 ? rationGuid : undefined);
      await this.getFeedSchedule();
      this.mergeRationDialog = false;
    } catch (err) {
      // putMergeSession displays the failure; stop before patching more kraals.
    } finally {
      this.merging = false;
    }
  }

  forceOpenSession() {
    for (let item of this.selectedFeedSchedules) {
      this.putOpenSession(item);
    }
  }
  get themeClass(): string {
    return this.$store.state.lightDarkMode;
  }

  get breadcrumbs() {
    return homeBreadcrumbs({ text: "Feeding Schedule", disabled: true });
  }

  async putMergeSession(guid: string, recordPatch = true, rationGuid?: string) {
    if (this.replay) return;
    try {
      console.log("updateServer()");
      let json = await this.$store.dispatch(
        "graphQl",
        {
          gql: `mutation mergeSession($guid:String!, $kraalGuid: String!, $user: String!, $recordPatch: Boolean!${rationGuid ? ", $rationGuid: String" : ""}) {
            mergeSession(guid:$guid, kraalGuid: $kraalGuid, user: $user, recordPatch: $recordPatch${rationGuid ? ", rationGuid: $rationGuid" : ""})
          }`,
          variables: {
            guid: this.$store.state.user.location.guid,
            kraalGuid: guid,
            user: this.patchUserMetadata,
            recordPatch,
            ...(rationGuid ? { rationGuid } : {}),
          },
        },
        { root: true }
      );

      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    } catch (err) {
      console.log(err);
      this.errorDialog = true;
      this.errorText = `Error saving to server: ${err} `;

      throw err;
    }
  }

  async putOpenSession(fsi: Model.FeedingScheduleItem) {
    if (this.replay) return;
    try {
      console.log("updateServer()");
      let json = await this.$store.dispatch(
        "graphQl",
        {
          gql: `mutation OpenSession($guid:String!, $input: FeedingScheduleItemInput!) {
        OpenSession(guid:$guid, input: $input) 
      }`,
          variables: { guid: this.$store.state.user.location.guid, input: fsi },
        },
        { root: true }
      );

      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    } catch (err) {
      console.log(err);
      this.errorDialog = true;
      this.errorText = `Error saving to server: ${err} `;

      throw err;
    }
  }
}
